import { useEffect } from "react";
import { useEditorCommands, useEditorState } from "@linempo/react-state";
import { errorMessage } from "../../editor-geometry.js";

export function useEditorShortcuts(disabled: boolean, onError: (message: string) => void, onDelete: () => void) {
  const state = useEditorState(); const commands = useEditorCommands();
  useEffect(() => {
    const handle = (event: KeyboardEvent) => {
      const target = event.target;
      if (disabled || event.defaultPrevented || event.isComposing || event.repeat || document.querySelector("dialog[open]") || target instanceof HTMLElement && (target.isContentEditable || target.closest("input, textarea, select, [contenteditable=true], dialog"))) return;
      let action: Promise<unknown> | undefined;
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "z") {
        if (event.shiftKey && state.history.canRedo) action = commands.redo();
        else if (!event.shiftKey && state.history.canUndo) action = commands.undo();
        event.preventDefault();
      } else if (!event.metaKey && !event.ctrlKey && !event.altKey && event.code === "Space") {
        event.preventDefault();
        const duration = state.prepare.plan?.durationMs ?? 0;
        const plan = state.prepare.plan;
        const ready = !!state.project && !!plan && state.prepare.status === "ready" && plan.projectId === state.project.id && plan.projectRevision === state.project.revision;
        if (state.preview.playing) action = commands.setPlaying(false);
        else if (duration > 0 && ready) action = (async () => {
          if (state.preview.requestedTimeMs >= duration) await commands.seek(0);
          await commands.setPlaying(true);
        })();
      } else if (!event.metaKey && !event.ctrlKey && !event.altKey && (event.key === "Delete" || event.key === "Backspace")) {
        event.preventDefault(); onDelete();
      }
      if (action) void action.catch((error: unknown) => onError(errorMessage(error)));
    };
    window.addEventListener("keydown", handle); return () => window.removeEventListener("keydown", handle);
  }, [commands, disabled, onError, onDelete, state.history.canRedo, state.history.canUndo, state.preview.playing, state.preview.requestedTimeMs, state.project, state.prepare.plan, state.prepare.status, state.selection.clipId]);
}
